export default __webpack_public_path__ + "static/media/RR.a325b49b.webp";